define('ScrollToLocation',[
    "jquery",
    "eventManager"
], function ($, eventManager) {

    // Listen to the facet selected trigger (news uses a different facet selected)
    // At this time for MM news is loaded last but if that is changed then this will
    // need to be changed as well

    // Research use "SearchResponseEvent:facet selected" as last trigger
    eventManager.subscribe("SearchResponseEvent:facet selected", function () {

        if (UserOnPage("/research")) {
            //console.log("%cSearchResponseEvent:facet selected", "color: red; font-family: sans-serif; font-size: 1.1em; font-weight: bolder;");
            setTimeout(function () {
                scrollToPosition();
            }, 800);
        }
    });

    // News/Events use "SearchResponseEvent:News facet selected" as last trigger
    eventManager.subscribe("SearchResponseEvent:News facet selected", function () {

        if (UserOnPage("/news-events")) {
            //console.log("%cSearchResponseEvent:News facet selected", "color: red; font-family: sans-serif; font-size: 1.1em; font-weight: bolder;");
            setTimeout(function () {
                scrollToPosition();
            }, 800);
        }
    });

    // Advisors use "SearchResponseEvent: trigger facet unchecked" as last trigger
    eventManager.subscribe("SearchResponseEvent: trigger facet unchecked", function () {

        if (UserOnPage("/advisors")) {
            //console.log("%cSearchResponseEvent: trigger facet unchecked", "color: red; font-family: sans-serif; font-size: 1.1em; font-weight: bolder;");
            setTimeout(function () {
                scrollToPosition();
            }, 800);
        }
    });

    // User is on the search page but in this case we will continue to run
    // our code until the elements have what we need or a certain amount of time has passed 
    if (UserOnPage("/search")) {
        var searchInterval;
        searchInterval = setInterval(function () {
            var tiles = [
                ".ipa-gs-search-results.ipa-gs-advisors > li > div.mm-tile", // Advisors
                ".ipa-gs-search-results.ipa-gs-research > li > div.mm-tile", // Research
                ".ipa-gs-search-results.ipa-gs-news > li > div.mm-tile"      // News
            ];

            loadWhenElementsHaveChildren(tiles, 10000, searchInterval);
        }, 200);
    }

    // This will continue to check that the elements in the elemArray exist or not
    // If they exist then it will run the scroll position but if they
    // never exist then the interval needs to be cleared
    //
    // elemArray - elements to monitor to make sure they exist
    // timeOutLimit - how long it can run before it needs to timeout if nothing can be found
    // interval - interval element that is set so it can be cleared
    function loadWhenElementsHaveChildren(elemArray, timeOutLimit, interval) {

        var childCount = 0;

        // loop through the elemArray to check if any elemArray have been loaded on the page
        elemArray.forEach(function (item, index, array) {
            //console.log("%citem = " + item, "color: blue; font-family: sans-serif; font-size: 1.1em; font-weight: bolder;");
            childCount += document.querySelectorAll(item).length;
        })

        // This will check if any of the elemArray given have loaded yet
        if (childCount > 0) {
            //console.log("%c" + childCount + " children were loaded", "color: green; font-family: sans-serif; font-size: 1.1em; font-weight: bolder;");
            scrollToPosition();
            clearInterval(interval);
        }
        else {
            //console.log("%cNo children were loaded", "color: red; font-family: sans-serif; font-size: 1.1em; font-weight: bolder;");
        }

        // In case it never loads like it should then clear the interval after a while
        setTimeout(function () {
            clearInterval(interval);
        }, timeOutLimit);
    }

    // Check if the user is on a certain page so that the correct subscription
    // will be called else it will cause it to not scroll to the correct area
    function UserOnPage(pageName) {
        if (document.location.pathname === pageName)
            return true;

        return false;
    }

    // This will take the scroll position in session storage to set the document
    function scrollToPosition() {
        var pathName = document.location.pathname;

        if (sessionStorage["scrollPosition_" + pathName]) {

            var scrollPosition = sessionStorage.getItem("scrollPosition_" + pathName);

            var previousUrl = getPreviousUrl();

            // Only scroll to the position if the previous path name is not the same
            // but you want to make sure the previous path at least contains the path name
            // because if the user is on /advisors and clicks Home and then clicks /advisors
            // then the previous url (Home) is not one that should trigger a scroll position
            if (pathName !== previousUrl && previousUrl.indexOf(pathName) >= 0) {
                //console.log("%cScrollPosition is called", "color: blue; font-family: sans-serif; font-size: 1.1em; font-weight: bolder;");
                $(document).scrollTop(scrollPosition);
            }

            // If the pathName is equal to "/search" then check to see if the following
            // previousUrl is coming from a certain area that would have involved "/search"
            // so that it will scroll to the area correctly
            if (pathName === "/search" &&
                (previousUrl.indexOf("/research") >= 0
                    || previousUrl.indexOf("/advisors") >= 0
                    || previousUrl.indexOf("/news-events") >= 0)) {
                $(document).scrollTop(scrollPosition);
            }


            // After setting the scroll top you have to delete it so that it won't keep 
            // sending the user to the same spot if they want to go to other search results
            sessionStorage.removeItem("scrollPosition_" + pathName);
        }
    }

    // Get the previous url by document.referrer or session storage 
    function getPreviousUrl() {

        // If document.referrer exists then get the path name
        // by creating a anchor element to easily parse out the path name
        if (document.referrer) {
            var a = document.createElement('a');
            a.href = document.referrer;
            var pathName = a.pathname;
            a = '';
            return pathName;
        }
        else
            return sessionStorage.getItem("previousUrl");
    }

    // Set the scroll location into the sessionStorage
    // so we know where to send the user when they click "Back to Search Results"
    function setScrollLocation() {
        var pathName = document.location.pathname;

        // Only add the scroll position for the following pages
        var includePath = [
            "/research",
            "/advisors",
            "/news-events",
            "/search"
        ].includes(pathName);

        var scrollPosition = $(document).scrollTop();

        // If the path name contains the global search page
        // then add the url parameters as well
        if (pathName === "/search")
            sessionStorage.setItem("previousUrl", pathName + document.location.search);
        else
            sessionStorage.setItem("previousUrl", pathName);

        if (includePath)
            sessionStorage.setItem("scrollPosition_" + pathName, scrollPosition.toString());
    }

    // When the page is unloaded then the scroll top will be captured
    $(function () {

        // Android and other phones
        window.onbeforeunload = function () {
            setScrollLocation();
        };

        // This is needed for iPhones and iPads since
        // onBeforeUnload does not work
        window.onpagehide = function () {
            setScrollLocation();
        };
    });

});
